import { Suspense, lazy, ReactElement } from "react";
import { Spinner } from "@vwfs-bronson/bronson-react";

const BLUELABEL = lazy(() => import("./bluelabel"));

export const ThemeSelector = ({ children }: { children: ReactElement }) => {
    return (
        <>
            <Suspense fallback={<Spinner fullPage></Spinner>}>
                <BLUELABEL>{children}</BLUELABEL>
            </Suspense>
        </>
    );
};
